import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import '../styles/Menu.css';
import ViewLogo from '../assets/View7.png';
import { FiMenu} from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-toastify';
import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa';
import { FaMapMarkerAlt } from "react-icons/fa";
import type { IconType } from 'react-icons';
import { 
  FiHome, 
  FiCoffee, 
  FiGift, 
  FiClock, 
  FiX 
} from "react-icons/fi";
const FiWine = FiCoffee;
type Filtro1 = "INICIO" | "COMIDA" | "BEBIDA" | "VINOS" | "PAQUETES" | "HORARIOS";

interface MenuItem {
  label: string;
  icon?: React.FC<{ size?: number; color?: string }>;
  filtroKey: Filtro1;
}

const FaHomeIcon = FiHome as React.FC<{ size?: number; color?: string }>;
const FaUtensilsIcon = FiCoffee as React.FC<{ size?: number; color?: string }>;
const FaWineIcon = FiWine as React.FC<{ size?: number; color?: string }>;
const FaGiftIcon = FiGift as React.FC<{ size?: number; color?: string }>;
const FaClockIcon = FiClock as React.FC<{ size?: number; color?: string }>;
const FiXIcon = FiX as React.FC<{ size?: number; color?: string }>;

const menuItems: MenuItem[] = [
  { label: "Inicio", icon: FaHomeIcon, filtroKey: "INICIO" },
  { label: "Menú Comida", filtroKey: "COMIDA" },
  { label: "Menú Bebida", filtroKey: "BEBIDA" },
  { label: "Menú Vinos", filtroKey: "VINOS" },
  { label: "Paquetes", icon: FaGiftIcon, filtroKey: "PAQUETES" },
  { label: "Horarios", icon: FaClockIcon, filtroKey: "HORARIOS" },
];

interface LateralMenuProps {
  menuAbierto: boolean;
  setMenuAbierto: (v: boolean) => void;
  filtro1: Filtro1;
  setFiltro1: (v: Filtro1) => void;
  setFiltroSeleccionado: (v: Filtro1) => void;
  setVideoListo: (v: boolean) => void;
  setMostrarHorarios: (v: boolean) => void;
}

const MarkerIcon = FaMapMarkerAlt as unknown as React.FC<{ size?: number; color?: string }>;


interface Producto {
  _id: string;
  nombre: string;
  precio: number;
  img?: string;
  categoria?: {
    nombre: string;
  };
}



const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
});

const getProductos = () => API.get('/productos');

const CATEGORIAS_COMIDA = [
  'ENTRADAS',
  'CARNES A LA PARRILLA',
  'ENSALADAS',
  'GUARNICIONES EXTRAS',
  'PASTAS',
  'SALSAS EXTRAS',
  'OTROS',
  'POSTRES',
];

const CATEGORIAS_BEBIDA = ['GASEOSAS Y JUGOS', 'CAFETERIA', 'CERVEZAS', 'TRAGOS','COCTELES'];

const CATEGORIAS_VINOS = [
  'VINOS TINTOS',
  'VINOS BLANCOS Y ROSADOS',
  'CHAMPAGNE Y ESPUMANTES',
];

// Orden maestro para todas las categorías, usado para mostrar siempre en este orden
const ordenCategoriasMaestro: string[] = [
  'ENTRADAS',
  'CARNES A LA PARRILLA',
  'ENSALADAS',
  'GUARNICIONES EXTRAS',
  'PASTAS',
  'SALSAS EXTRAS',
  'OTROS',
  'POSTRES',
  'GASEOSAS Y JUGOS',
  'CAFETERIA',
  'CERVEZAS',
  'TRAGOS',
  'COCTELES',
  'VINOS TINTOS',
  'VINOS BLANCOS Y ROSADOS',
  'CHAMPAGNE Y ESPUMANTES',
  'PAQUETES',
  'INFRAESTRUCTURA'
];

// ✅ SOLO AÑADIDO: agregamos 'INICIO' al tipo
type Filtro = 'INICIO' | 'COMIDA' | 'BEBIDA' | 'VINOS' | 'PAQUETES' | 'INFRAESTRUCTURA' | 'TODOS' | null;

interface ReservaDatos {
    nombre: string;
    telefono: string;
    fecha: string;
    hora: string;
    personas: number;
  }
  
  const minFecha = new Date().toISOString().split('T')[0];
  const maxFecha = (() => {
    const d = new Date();
    d.setMonth(d.getMonth() + 2);
    return d.toISOString().split('T')[0];
  })();
  
  const generarOpcionesHora = (): string[] => {
    const opciones: string[] = [];
    const pad = (n: number) => n.toString().padStart(2, '0');
  
    for (let h = 12; h <= 15; h++) {
      for (let m = 0; m < 60; m += 15) {
        if (h === 15 && m > 0) continue;
        opciones.push(`${pad(h)}:${pad(m)}`);
      }
    }
    for (let h = 18; h <= 22; h++) {
      for (let m = 0; m < 60; m += 15) {
        if (h === 18 && m < 30) continue;
        if (h === 22 && m > 30) continue;
        opciones.push(`${pad(h)}:${pad(m)}`);
      }
    }
    return opciones;
  };
  
  const validarHora = (horaStr: string) => {
    if (!horaStr) return false;
    const [hh, mm] = horaStr.split(':').map(Number);
    const minutosTotales = hh * 60 + mm;
    const rango1Inicio = 12 * 60;
    const rango1Fin = 15 * 60;
    const rango2Inicio = 18 * 60 + 30;
    const rango2Fin = 22 * 60 + 30;
    return (
      (minutosTotales >= rango1Inicio && minutosTotales <= rango1Fin) ||
      (minutosTotales >= rango2Inicio && minutosTotales <= rango2Fin)
    );
  };

const Menu = () => {
  const [productos, setProductos] = useState<Producto[]>([]);
  const [menuAbierto, setMenuAbierto] = useState(false);

  // ✅ NO CAMBIO el valor inicial: sigues en 'COMIDA' por defecto
  const [filtroSeleccionado, setFiltroSeleccionado] = useState<Filtro>('INICIO');

  const [mostrarHorarios, setMostrarHorarios] = useState(false);
  const [mostrarReserva, setMostrarReserva] = useState(false);
  const [errorHora, setErrorHora] = useState<string | null>(null);

  const menuRef = useRef<HTMLDivElement>(null);
 
 
  const [showMapa, setShowMapa] = useState(false); // <-- estado para mostrar/ocultar mapa
  const mapaRef = useRef<HTMLDivElement>(null);    // <-- referencia del popup del mapa

  const [filtro1, setFiltro1] = useState<Filtro1>('INICIO');


// Estado para el video del inicio
{/*const [videoInicio, setVideoInicio] = useState<string | undefined>(undefined);
useEffect(() => {
  getProductos()
    .then((res) => {
      setProductos(res.data.productos);

      // 👇 Buscar el producto de INICIO por ID y guardar su video
      const prodInicio = res.data.productos.find(
        (p: Producto) => p._id === "659e110a5b2e6464dacbbf5e"
      );
      if (prodInicio?.video) {
        setVideoInicio(prodInicio.video);
      }
    })
    .catch((err) => console.error("Error al obtener productos:", err));
}, []);*/}

  // Cerrar mapa si se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (mapaRef.current && !mapaRef.current.contains(event.target as Node)) {
        setShowMapa(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  
  // Estado para formulario de reserva
  const [reservaDatos, setReservaDatos] = useState({
    nombre: '',
    telefono: '',
    fecha: '',
    hora: '',
    personas: 1,
  });

  useEffect(() => {
    getProductos()
      .then((res) => setProductos(res.data.productos))
      .catch((err) => console.error('Error al obtener productos:', err));
  }, []);

  // Cerrar menú si se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        menuAbierto &&
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setMenuAbierto(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuAbierto]);

  // Cerrar modal con ESC
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (mostrarHorarios) setMostrarHorarios(false);
        if (mostrarReserva) setMostrarReserva(false);
      }
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [mostrarHorarios, mostrarReserva]);

  const productosPorCategoria = productos.reduce(
    (acc: { [key: string]: Producto[] }, producto) => {
      const categoria = producto.categoria?.nombre || 'Sin Categoría';
      if (!acc[categoria]) acc[categoria] = [];
      acc[categoria].push(producto);
      return acc;
    },
    {}
  );

  const getCategoriasFiltradas = (): string[] => {
    let categorias: string[] = [];

    switch (filtroSeleccionado) {
      case 'COMIDA':
        categorias = CATEGORIAS_COMIDA;
        break;
      case 'BEBIDA':
        categorias = CATEGORIAS_BEBIDA;
        break;
      case 'VINOS':
        categorias = CATEGORIAS_VINOS;
        break;
      case 'PAQUETES':
        categorias = ['PAQUETES'];
        break;
      case 'INFRAESTRUCTURA':
        categorias = ['INFRAESTRUCTURA'];
        break;
      case 'TODOS':
        categorias = Object.keys(productosPorCategoria);
        break;
      // ✅ INICIO no muestra categorías; dejamos el default vacío
      default:
        categorias = [];
    }

    // Filtrar para que solo salgan categorías que estén en el orden maestro
    categorias = categorias.filter((cat) => ordenCategoriasMaestro.includes(cat));

    // Ordenar según el arreglo maestro
    categorias.sort(
      (a, b) =>
        ordenCategoriasMaestro.indexOf(a) - ordenCategoriasMaestro.indexOf(b)
    );

    return categorias;
  };

  const categoriasMostradas = getCategoriasFiltradas();

  const drawerVariants = {
    hidden: { x: '100%' },
    visible: { x: 0 },
    exit: { x: '100%' },
  };

  const [loading, setLoading] = useState(false);

  const handleReservaChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setReservaDatos((prev) => ({
      ...prev,
      [name]: name === 'personas' ? Number(value) : value,
    }));

    if (name === 'hora') {
      if (validarHora(value)) {
        setErrorHora(null);
      } else {
        setErrorHora('La hora debe estar entre 12:00-15:00 o 18:30-22:30');
      }
    }
  };

  const handleReservaSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (errorHora) {
      alert('Corrige el error en la hora antes de enviar');
      return;
    }

    if (!reservaDatos.fecha || !reservaDatos.hora) {
      alert('Por favor, ingresa fecha y hora válidas');
      return;
    }

    // Crear objeto Date con fecha + hora
    const [hh, mm] = reservaDatos.hora.split(':').map(Number);
    const fechaHora = new Date(reservaDatos.fecha);
    fechaHora.setHours(hh, mm, 0, 0);

    // Validar rango fecha
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaMax = new Date(hoy);
    fechaMax.setMonth(fechaMax.getMonth() + 2);

    if (fechaHora < hoy) {
      alert('La fecha y hora no pueden ser en el pasado');
      return;
    }

    if (fechaHora > fechaMax) {
      alert('La fecha máxima permitida es 2 meses desde hoy');
      return;
    }

    try {
      setLoading(true);
      await API.post('/reservas', {
        nombre: reservaDatos.nombre,
        telefono: reservaDatos.telefono,
        fecha: fechaHora.toISOString(),
        cantidad: reservaDatos.personas,
       // usuario: '65483805b1889efceefa7a29' 
      });

      toast.success(`Reserva creada con éxito para ${reservaDatos.nombre}`);
      setMostrarReserva(false);

      setReservaDatos({
        nombre: '',
        telefono: '',
        fecha: '',
        hora: '',
        personas: 1,
      });
    } catch (error: any) {
        toast.error('Error al enviar la reserva');
      //alert('Error al enviar la reserva: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };
  

// Función para renderizar íconos correctamente
//const renderIcon = (Icon: IconType, color: string, size: number) =>
//  React.createElement(Icon, { size, style: { marginRight: "0.75rem", color } });
// Función para manejar clicks
const handleClick = (filtroKey: Filtro1) => {
  setFiltro1(filtroKey);
  setMenuAbierto(false);
  if (filtroKey === "INICIO") {
    setFiltroSeleccionado('INICIO');
    setMenuAbierto(false);
  };
  if (filtroKey === "COMIDA") {
    setFiltroSeleccionado('COMIDA');
                      setMenuAbierto(false);
  }
  if (filtroKey === "BEBIDA") {
    setFiltroSeleccionado('BEBIDA');
                      setMenuAbierto(false);
  }
  if (filtroKey === "VINOS") {
    setFiltroSeleccionado('VINOS');
                      setMenuAbierto(false);
  }
  if (filtroKey === "PAQUETES") {
    setFiltroSeleccionado('PAQUETES');
                      setMenuAbierto(false);
  }
  if (filtroKey === "HORARIOS") {
    setMenuAbierto(false);
    setMostrarHorarios(true);
  }
};


  return (
    <>
      {/* BARRA SUPERIOR */}
      <div className="menu-header-bar">
        <img src={ViewLogo} alt="Logo" className="menu-logo" />
        {FiMenu({
          className: 'menu-icon',
          onClick: () => setMenuAbierto(true),
          color: 'white',
          size: 28,
          style: { cursor: 'pointer' },
        })}
      </div>

   {/* Drawer lateral y overlay */}
   <AnimatePresence>
      {menuAbierto && (
        <>
          {/* Overlay semitransparente */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            exit={{ opacity: 0 }}
            onClick={() => setMenuAbierto(false)}
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "black",
              zIndex: 998,
            }}
          />

          {/* Drawer lateral */}
          <motion.aside
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={drawerVariants}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "280px",
              height: "100vh",
              backgroundColor: "#fff",
              zIndex: 999,
              padding: "2rem",
              display: "flex",
              flexDirection: "column",
              boxShadow: "-3px 0 15px rgba(0,0,0,0.15)",
              fontFamily: '"Inter", Helvetica, Arial, sans-serif',
            }}
          >
            {/* Botón cerrar */}
            <button
              onClick={() => setMenuAbierto(false)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                alignSelf: "flex-end",
                padding: "0.25rem",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget as HTMLElement).style.transform = "scale(1.1)"
              }
              onMouseLeave={(e) =>
                (e.currentTarget as HTMLElement).style.transform = "scale(1)"
              }
            >
              <FiXIcon size={28} color="#555" />
            </button>

            <nav style={{ marginTop: "1.5rem" }}>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {/* Inicio */}
                <li
                  key="INICIO"
                  style={{
                    padding: "1rem 0",
                    fontSize: "1rem",
                    cursor: "pointer",
                    fontWeight: filtro1 === "INICIO" ? 600 : 400,
                    color: filtro1 === "INICIO" ? "#E13F44" : "#333",
                    display: "flex",
                    alignItems: "center",
                    transition: "color 0.3s ease",
                  }}
                  onClick={() => handleClick("INICIO")}
                  onMouseEnter={(e) =>
                    (e.currentTarget as HTMLElement).style.color = "#E13F44"
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget as HTMLElement).style.color =
                      filtro1 === "INICIO" ? "#E13F44" : "#333"
                  }
                >
                  <span style={{ marginRight: "0.75rem", display: "inline-flex" }}>
                    <FaHomeIcon size={18} color={filtro1 === "INICIO" ? "#E13F44" : "#555"} />
                  </span>
                  Inicio
                </li>

                {/* Subtítulo Menú */}
                <li
                  style={{
                    marginTop: "1.5rem",
                    marginBottom: "0.5rem",
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#888",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                  }}
                >
                  Menú
                </li>

                {/* Subitems */}
                {["COMIDA", "BEBIDA", "VINOS"].map((filtroKey) => {
                  const labelMap: Record<string, string> = {
                    COMIDA: "Comida",
                    BEBIDA: "Bebida",
                    VINOS: "Vinos",
                  };
                  return (
                    <li
                      key={filtroKey}
                      style={{
                        padding: "0.75rem 0 0.75rem 1.5rem",
                        fontSize: "0.95rem",
                        cursor: "pointer",
                        fontWeight: filtro1 === filtroKey ? 500 : 400,
                        color: filtro1 === filtroKey ? "#E13F44" : "#555",
                        transition: "color 0.3s ease",
                      }}
                      onClick={() => handleClick(filtroKey as Filtro1)}
                      onMouseEnter={(e) =>
                        (e.currentTarget as HTMLElement).style.color = "#E13F44"
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget as HTMLElement).style.color =
                          filtro1 === filtroKey ? "#E13F44" : "#555"
                      }
                    >
                      {labelMap[filtroKey]}
                    </li>
                  );
                })}

                {/* Otros items */}
                {["PAQUETES", "HORARIOS"].map((filtroKey) => {
                  const labelMap: Record<string, string> = {
                    PAQUETES: "Paquetes",
                    HORARIOS: "Horarios",
                  };
                  const IconMap: Record<string, any> = {
                    PAQUETES: FaGiftIcon,
                    HORARIOS: FaClockIcon,
                  };
                  const Icon = IconMap[filtroKey];
                  return (
                    <li
                      key={filtroKey}
                      style={{
                        padding: "1rem 0",
                        fontSize: "1rem",
                        cursor: "pointer",
                        fontWeight: filtro1 === filtroKey ? 600 : 400,
                        color: filtro1 === filtroKey ? "#E13F44" : "#555",
                        display: "flex",
                        alignItems: "center",
                        transition: "color 0.3s ease",
                      }}
                      onClick={() => handleClick(filtroKey as Filtro1)}
                      onMouseEnter={(e) =>
                        (e.currentTarget as HTMLElement).style.color = "#E13F44"
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget as HTMLElement).style.color =
                          filtro1 === filtroKey ? "#E13F44" : "#555"
                      }
                    >
                      <span style={{ marginRight: "0.75rem", display: "inline-flex" }}>
                        <Icon size={18} color={filtro1 === filtroKey ? "#E13F44" : "#555"} />
                      </span>
                      {labelMap[filtroKey]}
                    </li>
                  );
                })}
              </ul>
            </nav>
          </motion.aside>
        </>
      )}
    </AnimatePresence>







      {/* Modal Horarios */}
      <AnimatePresence>
        {mostrarHorarios && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setMostrarHorarios(false)}
              style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 998,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '1rem',
              }}
            >
              <motion.div
                role="dialog"
                aria-modal="true"
                initial={{ scale: 0.95, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.95, opacity: 0 }}
                transition={{ type: 'spring', stiffness: 300, damping: 25 }}
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: '#ffffff',
                  zIndex: 999,
                  borderRadius: '12px',
                  padding: '1.5rem',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                  textAlign: 'center',
                  width: '100%',
                  maxWidth: '420px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0.75rem',
                  }}
                >
                  <h2
                    style={{
                      margin: 0,
                      fontSize: '1.25rem',
                      color: '#111',
                    }}
                  >
                    Horarios de Atención
                  </h2>
                  <button
                    onClick={() => setMostrarHorarios(false)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    aria-label="Cerrar horarios"
                  >
                    {FiX({ size: 20 })}
                  </button>
                </div>

                <div style={{ marginTop: '0.25rem', color: '#444' }}>
                  <p style={{ margin: 0, fontSize: '1rem', color: '#555' }}>Lunes a Sábado</p>
                  <p
                    style={{
                      margin: '6px 0 10px',
                      fontWeight: 700,
                      color: '#000',
                    }}
                  >
                    12:00 a 15:00 | 18:30 a 22:30
                  </p>

                  <p style={{ margin: 0, fontSize: '1rem', color: '#555' }}>Domingos</p>
                  <p
                    style={{
                      margin: '6px 0 0',
                      fontWeight: 700,
                      color: '#000',
                    }}
                  >
                    12:00 a 16:00
                  </p>
                </div>

                <div style={{ marginTop: '1rem' }}>
                  <button
                    onClick={() => setMostrarHorarios(false)}
                    style={{
                      padding: '0.55rem 1rem',
                      borderRadius: '8px',
                      border: 'none',
                      background: 'rgb(225,63,68)',
                      color: '#fff',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    Cerrar
                  </button>
                </div>
              </motion.div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Modal Reserva */}
      <AnimatePresence>
        {mostrarReserva && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setMostrarReserva(false)}
            style={{
              position: 'fixed',
              inset: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 998,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '1rem',
            }}
          >
            <motion.div
              role="dialog"
              aria-modal="true"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 300, damping: 25 }}
              onClick={(e) => e.stopPropagation()}
              style={{
                backgroundColor: '#ffffff',
                zIndex: 999,
                borderRadius: '12px',
                padding: '1.5rem',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                width: '100%',
                maxWidth: '420px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '0.75rem',
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: '1.25rem',
                    color: '#111',
                  }}
                >
                  Formulario de Reserva
                </h2>
                <button
                  onClick={() => setMostrarReserva(false)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  aria-label="Cerrar reserva"
                >
                {FiX({ size: 20 })} 
                  
                </button>
              </div>

              <form onSubmit={handleReservaSubmit}>
                <label
                  style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}
                  htmlFor="nombre"
                >
                  Nombre:
                  <input
                    id="nombre"
                    type="text"
                    name="nombre"
                    value={reservaDatos.nombre}
                    onChange={handleReservaChange}
                    required
                    placeholder="Tu nombre"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      marginTop: '0.25rem',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                    }}
                  />
                </label>

                <label
                  style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}
                  htmlFor="telefono"
                >
                  Teléfono:
                  <input
                    id="telefono"
                    type="tel"
                    name="telefono"
                    value={reservaDatos.telefono}
                    onChange={handleReservaChange}
                    required
                    placeholder="Ej. 71234567"
                    min="10000000"
                    step="1"
                    pattern="^\+?\d{8,15}$"
                    title="El teléfono debe tener al menos 8 dígitos numericos"
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      marginTop: '0.25rem',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                    }}
                  />
                </label>

                <label
                  style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}
                  htmlFor="fecha"
                >
                  Fecha:
                  <input
                    id="fecha"
                    type="date"
                    name="fecha"
                    value={reservaDatos.fecha}
                    onChange={handleReservaChange}
                    required
                    min={minFecha}
                    max={maxFecha}
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      marginTop: '0.25rem',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                    }}
                  />
                </label>

                <label
                  style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}
                  htmlFor="hora"
                >
                  Hora:
                  <select
                    id="hora"
                    name="hora"
                    value={reservaDatos.hora}
                    onChange={handleReservaChange}
                    required
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      marginTop: '0.25rem',
                      borderRadius: '6px',
                      border: errorHora ? '2px solid red' : '1px solid #ccc',
                    }}
                  >
                    <option value="">Selecciona una hora</option>
                    {generarOpcionesHora().map((hora) => (
                      <option key={hora} value={hora}>
                        {hora}
                      </option>
                    ))}
                  </select>
                </label>
                {errorHora && (
                  <p
                    style={{
                      color: 'red',
                      marginTop: '-0.5rem',
                      marginBottom: '0.5rem',
                      fontSize: '0.85rem',
                    }}
                  >
                    {errorHora}
                  </p>
                )}

                <label
                  style={{ display: 'block', marginBottom: '1rem', fontWeight: 600 }}
                  htmlFor="personas"
                >
                  Personas:
                  <select
                    id="personas"
                    name="personas"
                    value={reservaDatos.personas}
                    onChange={handleReservaChange}
                    required
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      marginTop: '0.25rem',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                    }}
                  >
                    {[...Array(20)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </label>

                <button
                  type="submit"
                  disabled={!!errorHora || loading}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: 'rgb(225,63,68)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 700,
                    cursor: loading ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.7 : 1,
                  }}
                >
                  {loading ? 'Enviando...' : 'Enviar Reserva'}
                </button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>



      {filtroSeleccionado === 'INICIO' && (
  <div style={{ width: '100%', overflow: 'hidden' }}>
    {/* Hero con video */}
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '70vh',
        maxHeight: '90vh',
        overflow: 'hidden',
      }}
    >
  {/*} {videoInicio && (*/}
  <div
  style={{
    position: "absolute",
    inset: 0,
    zIndex: 0,
    backgroundImage:
      "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(https://res.cloudinary.com/dasosa1iv/image/upload/f_auto,q_auto,w_1920,c_fill/qs2le0uk5ppjt4rnfhrk.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    transform: "translateZ(0)",
  }}
/>
{/*})}*/}
      {/* Texto transparente encima del video */}
      <div
        style={{
          position: 'absolute',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#FFF',
          textAlign: 'center',
          zIndex: 1,
          padding: '0 1rem',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            margin: '0 0 0.5rem 0',
          }}
        >
          Bienvenido a <span style={{ color: 'rgb(225,63,68)' }}>View</span>
        </h1>
        <p
          style={{
            fontSize: 'clamp(1rem, 2.2vw, 1.2rem)',
            margin: 0,
          }}
        >
          Vive una experiencia gastronómica única, con el mejor ambiente y sabores inolvidables.
        </p>
      </div>

 {/* Cuadro blanco solo para botones */}
<motion.div
  className="animated-box"
  initial={{ opacity: 0, y: -400, rotateX: 25 }}
  animate={{ opacity: 1, y: 0, rotateX: 0 }}
  transition={{ duration: 4, ease: "easeOut" }}
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap",
  }}
>
  {/* IZQUIERDA: Ir a + botón Reservar (igual que Menú) */}
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span>Ir a</span>
    <button
      onClick={() => window.open("https://reservas.viewrestaurante.com", "_self")}
      style={{
        background: "rgb(225,63,68)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "0.45rem 0.95rem",
        fontWeight: 700,
        cursor: "pointer",
      }}
    >
      Reservar
    </button>
  </div>

  {/* DERECHA: Explorar + botón Menú (igual como está) */}
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <span>Explorar</span>
    <button
      onClick={() => setFiltroSeleccionado("COMIDA")}
      style={{
        background: "rgb(225,63,68)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "0.45rem 0.95rem",
        fontWeight: 700,
        cursor: "pointer",
      }}
    >
      Menú
    </button>
  </div>
</motion.div>

    </div>

    {/* Footer negro visible */}
    <div
      style={{
        background: '#000',
        color: '#FFF',
        padding: '2rem 1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: '1rem',
        }}
      >
      <div
  style={{
    flex: "1 1 45%",
    display: "flex",
    flexDirection: "column",
    gap: "0.8rem",
  }}
>
 

  {/* Horarios */}
  <div style={{ display: "flex", flexDirection: "column" }}>
    <h3 style={{ fontSize: "clamp(0.95rem, 2vw, 1rem)", fontWeight: 600, margin: 0, color: "#FFF" }}>
      Horarios de Atención
    </h3>
    <p style={{ fontSize: "clamp(0.85rem, 1.8vw, 0.95rem)", color: "#FFF", margin: "0.2rem 0 0 0" }}>
      Lunes a Sábado: 12:00 a 15:00 | 18:30 a 22:30
    </p>
    <p style={{ fontSize: "clamp(0.85rem, 1.8vw, 0.95rem)", color: "#FFF", margin: "0.2rem 0 0 0" }}>
      Domingos: 12:00 a 16:00
    </p>
  </div>
</div>

  {/* Redes sociales + Dirección */}
<div
  style={{
    textAlign: "right",
    minWidth: "240px",
    display: "flex",
    flexDirection: "column",
    gap: "0.8rem",
  }}
>
  {/* Redes */}
  <div style={{ display: "flex", flexDirection: "column" }}>
    <p style={{ fontSize: "clamp(0.9rem, 2vw, 1.2rem)", margin: 0 }}>
      Síguenos en redes sociales
    </p>

    <div
      style={{
        margin: "0.5rem 0 0 0",
        display: "flex",
        justifyContent: "flex-end",
        gap: "clamp(0.5rem, 2vw, 1rem)",
      }}
    >
      <a
        href="https://www.facebook.com/share/19qJiCnXxz/?mibextid=wwXIfr"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#FFF", fontSize: "clamp(1.2rem, 4vw, 1.5rem)" }}
      >
        {FaFacebookF({})}
      </a>

      <a
        href="https://www.instagram.com/view.restaurante?igsh=MXh1dnVyeTN0bXhmYQ%3D%3D&utm_source=qr"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#FFF", fontSize: "clamp(1.2rem, 4vw, 1.5rem)" }}
      >
        {FaInstagram({})}
      </a>

      <a
        href="https://www.tiktok.com/@view.restaurante?_t=ZS-8zGGhUqYTUW&_r=1"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#FFF", fontSize: "clamp(1.2rem, 4vw, 1.5rem)" }}
      >
        {FaTiktok({})}
      </a>
    </div>
  </div>

  {/* Dirección debajo */}
  <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
  

    <a
      href="https://www.google.com/maps?q=-17.37696,-66.15079"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#FFF",
        textDecoration: "underline",
        fontSize: "0.9rem",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "0.5rem",
        opacity: 0.9,
      }}
    >
      <MarkerIcon size={16} color="rgb(225,63,68)" />
      Dirección
    </a>
  </div>
</div>
      </div>

      {/* Copyright */}
      <p style={{ fontSize: 'clamp(0.6rem, 1vw, 0.8rem)', marginTop: '0.5rem', textAlign: 'center', color: '#AAA' }}>
        © 2025 Viewrestaurante — Empresa registrada oficialmente en Bolivia.
      </p>
    </div>
  </div>
)}








      {/* CONTENIDO PRINCIPAL (idéntico) — se oculta cuando estás en INICIO */}
      {filtroSeleccionado !== 'INICIO' && (
        <div className="menu-container" style={{ padding: '2rem' }}>
          <h1 className="menu-title">Menú</h1>

          {categoriasMostradas.map((categoria) => {
            const productosCategoria = productosPorCategoria[categoria];
            if (!productosCategoria) return null;

            return (
              <div key={categoria} className="categoria-section">
                <h2 className="categoria-titulo">{categoria}</h2>
                <div className="productos-grid">
                  {productosCategoria.map((producto) => (
                    <div key={producto._id} className="producto-card">
                      {producto.img && (
                        <img
                          src={producto.img}
                          alt={producto.nombre}
                          className="producto-img"
                        />
                      )}
                      {categoria !== "INFRAESTRUCTURA" && (
                      <>
                        <h3 className="producto-nombre">{producto.nombre}</h3>
                        <p className="producto-categoria">Bs. {producto.precio}</p>
                      </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default Menu;
